import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { id: "header__top" }
const _hoisted_2 = { class: "container-fluid l2" }
const _hoisted_3 = { class: "row g-0" }
const _hoisted_4 = ["innerHTML"]


export default /*@__PURE__*/_defineComponent({
  __name: 'BaseHeaderTop',
  props: {
  items: {
    type: Array,
    required: true,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_IoRouterLink = _resolveComponent("IoRouterLink")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (menuItem) => {
          return (_openBlock(), _createElementBlock("div", {
            key: menuItem.id,
            class: "col-auto"
          }, [
            _createVNode(_component_IoRouterLink, {
              "link-url": menuItem.url,
              "link-target": menuItem.target,
              "link-title": menuItem.titleAttr,
              active: menuItem.active
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", {
                  innerHTML: menuItem.title
                }, null, 8, _hoisted_4)
              ]),
              _: 2
            }, 1032, ["link-url", "link-target", "link-title", "active"])
          ]))
        }), 128)),
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "col" }, null, -1))
      ])
    ])
  ]))
}
}

})